module.exports = __webpack_public_path__ + "static/media/W18-0610_AW_SpicyGuac_LTO_Burger_Lineup_desktop_hero_2396x1473_EN.f1f58d9a.jpg";